module.exports = __webpack_public_path__ + "img/blue.c43cbaf9.png";